{
  // content-carousel: the carousel breaks out of the wrapper to the viewport edge while
  // the text content stays inside the wrapper — measure the in-wrapper content column
  // and size the absolute carousel to meet its edge.
  const sizeCarousels = () => {
    document.querySelectorAll('.content-carousel').forEach(block => {
      const carousel = block.querySelector('.content-carousel--carousel')
      const content = block.querySelector('.content-carousel--content')
      if (!carousel || !content) return

      // below the breakpoint the block stacks — clear inline sizing, let CSS take over
      if (window.innerWidth <= 768) {
        carousel.style.width = ''
        return
      }

      const contentRect = content.getBoundingClientRect()
      const isLeft = block.classList.contains('content-carousel--carousel-left')

      carousel.style.width = isLeft
        ? Math.max(0, contentRect.left) + 'px'
        : Math.max(0, window.innerWidth - contentRect.right) + 'px'
    })
  }

  window.addEventListener('load', sizeCarousels)
  window.addEventListener('resize', sizeCarousels)

  sizeCarousels()

  // on mobile move the carousel above the content so tab order matches the visual order
  // (no flex-reverse/css order so tabindex stays true)
  const swapForMobile = () => {
    document.querySelectorAll('.content-carousel--carousel-right').forEach(block => {
      const carousel = block.querySelector(':scope > .content-carousel--carousel')
      const wrapper = block.querySelector(':scope > .wrapper')
      if (!carousel || !wrapper) return
      const isCarouselFirst = !!(carousel.compareDocumentPosition(wrapper) & Node.DOCUMENT_POSITION_FOLLOWING)
      const wantCarouselFirst = window.innerWidth <= 768
      // only move when out of order -- moving re-fires ada-slider's connectedCallback
      if (wantCarouselFirst === isCarouselFirst) return
      if (wantCarouselFirst) block.insertBefore(carousel, wrapper)
      else block.insertBefore(wrapper, carousel)
    })
  }
  window.addEventListener('resize', swapForMobile)
  swapForMobile()

  // keep the image and text sliders in lockstep: advancing either (controls, swipe,
  // autoplay) moves both; only move the other slider when it isn't already on that index
  const sliderIndex = slider => {
    const current = slider.querySelector('.slick-current')
    return current ? parseInt(current.getAttribute('data-slick-index'), 10) : 0
  }
  const syncCarousels = () => {
    document.querySelectorAll('.content-carousel').forEach(block => {
      const imageSlider = block.querySelector('.content-carousel--carousel ada-slider')
      const textSlider = block.querySelector('.content-carousel--content ada-slider')
      if (!imageSlider || !textSlider) return

      const link = (source, target) => {
        jQuery(source).on('afterChange', (e, slick, current) => {
          if (sliderIndex(target) !== current) target.goToSlide(current)
        })
      }
      link(imageSlider, textSlider)
      link(textSlider, imageSlider)
    })
  }

  window.addEventListener('load', syncCarousels)
}
